import { createFileRoute } from "@tanstack/react-router";
import { ReportsPage } from "@/components/admin/reports/ReportsPage";

export const Route = createFileRoute("/dashboard/admin/reports")({
  component: AdminReportsPage,
});

function AdminReportsPage() {
  return (
    <div className="mx-auto max-w-6xl space-y-6 pb-14">
      <header className="flex flex-col gap-2">
        <h1
          className="text-3xl font-semibold leading-tight tracking-tight text-foreground sm:text-4xl"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          Izvještaji
        </h1>
        <p className="max-w-2xl text-sm text-muted-foreground">
          Analitički pregledi za prihode, isplate i operativne metrike platforme.
        </p>
      </header>

      <ReportsPage />
    </div>
  );
}
